module.exports = __webpack_public_path__ + "static/media/POWERGRID.83c3b06b.txt";